import { Link } from "react-router-dom";
import { BRAND } from "@/content";

const Footer = () => (
  <footer className="border-t border-stone/70 bg-cream/60" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-6 md:px-10 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <p className="font-serif text-xl tracking-[0.25em] text-charcoal">{BRAND}</p>
        <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer navigation">
          {[
            { to: "/regulate", label: "REGULATE" },
            { to: "/begin-here", label: "Begin Here" },
            { to: "/about", label: "About" },
            { to: "/about", label: "Contact" },
            { to: "/", label: "Privacy Policy" },
            { to: "/", label: "Terms" },
          ].map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs uppercase tracking-[0.2em] text-taupe hover:text-charcoal transition-colors duration-500"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <p className="mt-12 text-xs text-taupe/80 tracking-wide">
        © {new Date().getFullYear()} Tara Aurora. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
